// extracted by mini-css-extract-plugin
export default {"wrap":"NFCSMintImprove_wrap__6dSUK","item":"NFCSMintImprove_item__qXnmp","number":"NFCSMintImprove_number__PLF5R"};